/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { sports } from '../../data/sports';
import SelectCard from './SelectCard';
import SelectCardMovil from './SelectCardMovil';

export default function SelectSport({ className }: { className?: string }): JSX.Element {
    const [listSports, setListSports] = useState([]);
    const [active, setActive] = useState(false);

    const [slider, setSlider] = useState<any>({
        currentIndex: 0,
        items: [],
        responsive: { 0: { items: 1 }, 1024: { items: 8 } },
    });

    const handlerSlider = () => {
        setListSports(
            sports().map((s) => {
                return {
                    url: s.url,
                    image: s.image,
                    title: s.title,
                    alt: s.alt,
                };
            }),
        );
    };

    useEffect(() => {
        handlerSlider();
    }, []);

    useEffect(() => {
        const handlerSlider = () => {
            setSlider({
                ...slider,
                items: listSports.map((s) => {
                    return <SelectCardMovil key={s.title} sport={s} />;
                }),
            });
        };

        if (listSports && listSports.length > 0) {
            //console.log({ listSports });
            handlerSlider();
        }
    }, [listSports]);

    useEffect(() => {
        if (slider) {
            //console.log({ slider });
            setActive(true);
        }
    }, [slider]);

    const onSlideChanged = (e) => {
        setSlider({ ...slider, currentIndex: e.item });
    };
    return (
        <>
            <section
                className={`hidden md:flex relative z-20 justify-center items-center pb-20 px-10 sm:min-w-sport snap-x ${
                    className ? className : ''
                }`}
            >
                {listSports && listSports.length > 0 && listSports.map((s) => <SelectCard key={s.title} sport={s} />)}
            </section>
            <section>
                <div className={`block md:hidden  relative pt-6 z-20 pb-4 `} id="SliderSport">
                    <div className={`relative z-20`}>
                        {active && (
                            <AliceCarousel
                                mouseTracking
                                disableDotsControls={false}
                                disableButtonsControls={true}
                                activeIndex={slider.currentIndex}
                                infinite={false}
                                onSlideChanged={onSlideChanged}
                                responsive={slider.responsive}
                                items={slider.items}
                                keyboardNavigation={true}
                                paddingLeft={48}
                                paddingRight={48}
                                animationDuration={10}
                                animationType="fadeout"
                            />
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
